import React from 'react';
import PropTypes from 'prop-types';
import { gaWrapper } from 'helpers/analytics';
import s from './Pagination.scss';

const Pagination = props => {
  const { params = {}, count } = props;
  const { isGrid2Col } = props;
  const getMoreRecords = () => {
    const url = window.location && window.location.href;
    gaWrapper('send', 'event', props.gaCategory, 'click', 'seeMore');
    gaWrapper('send', 'pageview', url);
    params.curpg += 1;
    props.getMoreRecords(params, count);
  };

  if (params.curpg * 50 >= count || !count) return null;
  return (
    <div className={`${s.pagination} ${isGrid2Col ? '' : s.col2}`}>
      <div className={s.updateText}>
        {count - params.curpg * 50} More Updates
      </div>
      <button onClick={getMoreRecords}>See More Updates</button>
    </div>
  );
};

Pagination.propTypes = {
  params: PropTypes.shape({}).isRequired,
  count: PropTypes.number,
  getMoreRecords: PropTypes.func,
  isGrid2Col: PropTypes.bool,
};
Pagination.defaultProps = {
  count: 0,
  getMoreRecords: () => {},
  isGrid2Col: false,
};

export default Pagination;
